import { CalendarDays, CheckCircle2, FileDown, Mail, PencilLine, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const ReportReady = ({ sharedAt }) => (
  <div className="report-ready" data-testid="portal-report-ready">
    <FileDown className="h-5 w-5 shrink-0 text-[#0072C6]" />
    <p className="text-sm text-slate-700 flex-1">Your advisor shared your Financial Needs Analysis report{sharedAt ? ` on ${sharedAt}` : ""}.</p>
    <Button asChild size="sm" className="gap-1.5" data-testid="portal-report-download-button"><Link to="/portal/report"><FileDown className="h-4 w-4" /> Download my report (PDF)</Link></Button>
  </div>
);

export const ThankYou = ({ name, advisor, submittedAt, version, onReview, sharedAt }) => (
  <section className="thanks-card" data-testid="portal-thank-you">
    <div className="thanks-icon"><CheckCircle2 className="h-9 w-9" /></div>
    <p className="metric-label text-emerald-700" data-testid="thank-you-percent">100% complete</p>
    <h2 className="font-heading text-2xl sm:text-3xl font-extrabold text-[#0b2545] leading-tight">Thank you{name ? `, ${name.split(" ")[0]}` : ""}!</h2>
    <p className="text-sm sm:text-base text-slate-600 max-w-xl">
      Your financial assessment (version {version}) reached {advisor.name} on {submittedAt}. A confirmation email is on its way.
      The next step is a short meeting to walk through your results together.
    </p>
    {sharedAt !== null && <ReportReady sharedAt={sharedAt} />}
    <div className="thanks-actions">
      {advisor.booking_url && (
        <Button asChild size="lg" className="gap-2" data-testid="thank-you-book-button">
          <a href={advisor.booking_url} target="_blank" rel="noopener noreferrer"><CalendarDays className="h-4 w-4" /> Book my review meeting</a>
        </Button>
      )}
      <Button asChild size="lg" variant={advisor.booking_url ? "outline" : "default"} className="gap-2" data-testid="thank-you-email-button">
        <a href={`mailto:${advisor.email}?subject=${encodeURIComponent("My financial assessment")}`}><Mail className="h-4 w-4" /> Email {advisor.name.split(" ")[0]}</a>
      </Button>
      {advisor.phone && (
        <Button asChild size="lg" variant="outline" className="gap-2" data-testid="thank-you-call-button">
          <a href={`tel:${advisor.phone.replace(/[^0-9+]/g, "")}`}><Phone className="h-4 w-4" /> Call {advisor.phone}</a>
        </Button>
      )}
    </div>
    <button type="button" onClick={onReview} className="thanks-review" data-testid="thank-you-review-button"><PencilLine className="h-4 w-4" /> View or update my answers</button>
    <p className="text-[11px] text-slate-400">If you change anything, you'll be asked to resubmit so your advisor has the latest version.</p>
  </section>
);
